// Own module so FormRendererContext can use it without pulling in the whole renderer
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isActionResponseValid = (response: any): boolean =>
  Array.isArray(response) ? response.length > 0 : response !== null && response !== undefined && response !== '';
